import store from '@/store'
import router from '@/router'
import axios from 'axios'
import { IS_PRODUCTION, HTTP_STATUS, HTTP_HEADER_SKIP_ERROR } from '@/libs/constants'
import { isArray, isPlainObject } from '@/libs/utils'
import { getAuthToken, removeAuthData } from '@/libs/auth-helper'
import { SIGNIN_LINK } from './constants'

let baseUrl = 'http://localhost:5000'

if (process.env.VUE_APP_API_BASE_URL) {
  baseUrl = process.env.VUE_APP_API_BASE_URL
} else if (IS_PRODUCTION) {
  baseUrl = 'https://samsung-api.beusable.net'
}

function isApiUrl (url) {
  if (url.charAt(0) === '/') {
    return true
  }
  return url.indexOf(baseUrl) === 0
}

function normalizeRequest (data) {
  if (isPlainObject(data)) {
    for (const key of Object.keys(data)) {
      if (typeof data[key] === 'string') {
        data[key] = data[key].trim()
      } else {
        normalizeRequest(data[key])
      }
    }
  } else if (isArray(data)) {
    for (let i = 0; i < data.length; i++) {
      if (typeof data[i] === 'string') {
        data[i] = data[i].trim()
      } else {
        normalizeRequest(data[i])
      }
    }
  }
}

const httpClient = axios.create({
  baseURL: baseUrl
})

httpClient.interceptors.request.use(function (config) {
  if (isApiUrl(config.url)) {
    if (config.data) {
      normalizeRequest(config.data)
    }

    if (config.method === 'get') {
      if (!config.params) {
        config.params = {}
      }
      config.params.t = new Date().getTime()
    }

    const authToken = getAuthToken()

    if (authToken) {
      config.headers = Object.assign(config.headers, {
        Authorization: `Bearer ${authToken}`
      })
    }
  }
  return config
}, function (error) {
  return Promise.reject(error)
})

httpClient.interceptors.response.use(function (response) {
  if (response.headers['dream-version']) {
    const version = parseInt(response.headers['dream-version'])
    store.commit('setDreamVersion', version)
  }

  if (isApiUrl(response.config.url) && !response.data.success) {
    const message = response.data.message || 'RESPONSE_FAILED'
    const error = new Error(message)
    error.isFailed = true
    return Promise.reject(error)
  } else {
    return response
  }
}, function (error) {
  let needAlert = true

  if (error.config.headers[HTTP_HEADER_SKIP_ERROR]) {
    needAlert = false
  } else if (error.response && error.response.status) {
    const statusCode = error.response.status

    const authFailedStatusCodes = [
      HTTP_STATUS.unauthrized,
      HTTP_STATUS.unprocessableEntity
    ]
    if (authFailedStatusCodes.includes(statusCode)) {
      needAlert = false
      if (window.__VUE_ROOT__) {
        window.__VUE_ROOT__.$children[0].signOut()
      } else {
        removeAuthData()
      }
      window.location.href = SIGNIN_LINK
    } else if (statusCode === HTTP_STATUS.badRequest) {
      // to-do: what happened?
    }
  }

  if (needAlert) {
    error.isHandled = true
    store.commit('setErrorData', error)
  }
  return Promise.reject(error)
})

export default httpClient
